import { Action } from 'redux';

export enum DetailActions {
  SELECT = 'detail.select',
  REQUEST = 'detail.request',
  RESPONSE = 'detail.response',
  INVALIDATE = 'detail.invalidate',
  UPDATE_VALUE = 'detail.update_value',
  FILTER = 'detail.simple.filter',
  RESET = 'detail.simple.reset'
}

export type DetailReducerFunction = (
  state: DetailStoreState,
  action: DetailAction,
  config?: DetailStoreConfig
) => DetailStoreState;
export type DetailDataKeyFunction = (this: DetailStoreState) => string;

export interface DetailStoreState {
  data?: any;
  id?: any;
  isFetching: boolean;
  fetched: boolean;
  currentDataKey: string;
  filter: Object; // pokud je detai zobrazován na základě filtru
  getDataKey: DetailDataKeyFunction;
  reducer: DetailReducerFunction;
}

export interface DetailStoreConfig {
  filter?: any;
}

export interface DetailAction extends Action<string> {
  dataKey?: string;
  data?: any;
  id?: any;
  filter?: any;
}
